"use client";
import Card from "react-bootstrap/Card";

import { Link as ReactRouterLink } from "react-router-dom";
import "../styles/result-card-grid.css";

export const GridCardTitle = ({ id, name, primaryMembership, extraClass }) => {
  return (
    <div className={`card-header-section mb-3 ${extraClass}`}>
      <Card.Title className="director-name mb-2">
        <ReactRouterLink
          to={`/directors/${id}`}
          target="_blank"
          className="text-decoration-none fw-bold"
          style={{
            color: "#1E6685",
            fontSize: "1.1rem",
            lineHeight: "1.3",
          }}
        >
          {name}
        </ReactRouterLink>
      </Card.Title>

      <Card.Subtitle
        className="mb-0"
        style={{ fontSize: "0.9rem", lineHeight: "1.4" }}
      >
        {primaryMembership?.seat_name || "N/A"}
        {primaryMembership?.name && primaryMembership.name !== "N/A" && (
          <>
            <span className="text-muted">
              {" at "}
              {primaryMembership.link ? (
                <ReactRouterLink
                  to={`${primaryMembership.link}`}
                  target="_blank"
                  className="text-decoration-none"
                  style={{ color: "#1e6685", hover: "#138496" }}
                >
                  {primaryMembership.name}
                </ReactRouterLink>
              ) : (
                primaryMembership.name
              )}
            </span>
            <span
              className="ml-1 mr-2 text-muted"
              style={{ fontSize: "0.75rem" }}
            >
              •
            </span>
            <span className="text-muted">
              {primaryMembership.institution_type}
            </span>
          </>
        )}
      </Card.Subtitle>
    </div>
  );
};
